import { IRootReducerState } from "../../../redux-store/rootReducer";

export const resolveActor = (
  state: IRootReducerState
): {
  actor: string;
  actor_type: string;
  accountManager: { id: string; name: string; email: string };
  store: { id: string; name: string; image: string };
} => {
  const store = state.storeReducer?.store || state.authReducer?.storeData;
  const accountManager = state.storeReducer?.accountManager;
  const adminEmail = store?.admin_email || accountManager?.email || "";
  const auditActor = state.serviceAuditReducer?.auditActor;

  return {
    actor: auditActor?.email || auditActor?.name || adminEmail,
    actor_type: auditActor?.actor_type || "merchant",
    accountManager: {
      id: accountManager?.id || "",
      name: accountManager?.user_name || "",
      email: accountManager?.email || "",
    },
    store: {
      id: store?.id || "",
      name: store?.name || store?.en_name || "",
      image: store?.store_image || "",
    },
  };
};